import BaseModule from "~/vuex/modules/base-module";

let Ships = {...BaseModule};

Ships.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/ships';

    state.lastDate = null;
    state.sort = {};


    return state;
};

Ships.mutations.setName = function (state, data) {
    console.log(data);
    state.all[data.id].name = data.name;
};

export default Ships;
